<div class="dialogContainer" [ngClass]="{ 'visible': showEditModal }">
  <div class="dialog">
    <div class="cell large-12 medium-12 small-12 bold">
      Edit System Alert
    </div>
    @if (showEditModal) {
      <div class="cell large-12 medium-12 small-12">
        <form [formGroup]="alertForm">
          <label for="alertTitle" class="bold">Title:</label>
          <input id="alertTitle" type="text" [(ngModel)]="alert.title" formControlName="title" class="input-field" />
          <label for="alertMessage" class="bold">Message:</label>
          <textarea id="alertMessage" [(ngModel)]="alert.message" formControlName="message" class="input-field" rows="4"></textarea>
          <label for="startDate" class="bold">Start Date:</label>
          <input id="startDate" type="datetime-local" formControlName="startDate" class="input-field" />
          <label for="endDate" class="bold">End Date:</label>
          <input id="endDate" type="datetime-local" formControlName="endDate" class="input-field" />
          <!-- Error message for invalid date range -->
          @if (alertForm.errors?.dateRangeInvalid) {
            <div class="error">
              Start Date cannot be greater than End Date.
            </div>
          }
        </form>
      </div>
    }
    <div class="dialogButtonsContainer">
      <div class="text-align-center">
        <button class="button margin-left no-margin-bottom outline-offset-1" [disabled]="savingAlert" (click)="cancel()">Cancel</button>
        <button class="button margin-left no-margin-bottom outline-offset-1" [disabled]="alertForm.invalid || savingAlert" (click)="updateAlert()">Save</button>
      </div>
    </div>
    <text-loader [run]="savingAlert" [tickType]="'.'" [text]="'Saving Alert'" [interval]="1500"></text-loader>
  </div>
</div>